'use client';

import { forwardRef } from 'react';
import { cn } from '@/lib/utils';
import { CheckIcon } from '@heroicons/react/24/solid';

const Checkbox = forwardRef(function Checkbox(
  {
    label,
    description,
    error,
    className,
    ...props
  },
  ref
) {
  const isChecked = props.checked || false;

  return (
    <div className={cn(className)}>
      <label className="flex items-start gap-3 cursor-pointer">
        <div className="relative mt-0.5">
          <input
            ref={ref}
            type="checkbox"
            className="sr-only"
            {...props}
          />
          <div className={cn(
            'w-5 h-5 border-2 rounded-md transition-all duration-200',
            'flex items-center justify-center',
            isChecked ? 'border-blue-500 bg-blue-500' : (error ? 'border-red-500' : 'border-slate-300'),
          )}>
            <CheckIcon className={cn(
              'w-3 h-3 text-white transition-opacity duration-200',
              isChecked ? 'opacity-100' : 'opacity-0'
            )} />
          </div>
        </div>
        <div className="flex-1">
          <span className={cn(
            'text-sm',
            error ? 'text-red-500' : 'text-slate-700'
          )}>
            {label}
          </span>
          {description && (
            <p className="text-xs text-slate-500 mt-0.5">{description}</p>
          )}
        </div>
      </label>
      {error && typeof error === 'string' && (
        <p className="text-xs text-red-500 mt-1 ml-8">{error}</p>
      )}
    </div>
  );
});

export default Checkbox;
